export default __webpack_public_path__ + "static/3-e853c000c15c8846cdb75e8de68672b0.jpeg";